import React, { Children } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Crown, Monitor, ShieldCheck, Music, Sparkles, Volume2, Star, Wine } from 'lucide-react';
export function Nightlife() {
  const features = [{
    icon: Crown,
    title: 'VIP Tables',
    description: 'Premium bottle service with dedicated hosts and the best views of the dance floor.'
  }, {
    icon: Monitor,
    title: '190FT Video Wall',
    description: 'An immersive visual canvas that transforms the atmosphere every single night.'
  }, {
    icon: Music,
    title: 'World-Class DJs',
    description: 'The hottest tracks spun by top-tier talent from across the country.'
  }];
  const vipBenefits = ['Expedited VIP Entry', 'Dedicated Server & Security', 'Custom Digital Flyer', 'Premium Mixers Included', 'Prime Table Location', 'Shoutouts from the DJ'];
  const gallery = ['https://cdn.magicpatterns.com/uploads/va8WBqwRFPJVrp1Tyd8QNn/SnapInsta.to_684140561_18095297540328170_1227165002793297535_n.jpg', 'https://cdn.magicpatterns.com/uploads/iyPetroGroUojZdyUQXNKw/SnapInsta.to_684225988_18095297486328170_7779366325725060661_n.jpg', 'https://cdn.magicpatterns.com/uploads/s3K8wKdfybMP1zxoh7PS3W/SnapInsta.to_684049710_18095297510328170_549094879827346722_n.jpg'];
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-1426">
      <Header data-id="element-1427" />

      {/* Hero Section */}
      <section className="relative h-screen w-full flex items-center justify-center overflow-hidden pt-20 md:pt-32" data-id="element-1428">
        <div className="absolute inset-0 z-0" data-id="element-1429">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B1014] via-[#0B1014]/40 to-[#0B1014] z-10" data-id="element-1430" />
          <img src="https://cdn.magicpatterns.com/uploads/iyPetroGroUojZdyUQXNKw/SnapInsta.to_684225988_18095297486328170_7779366325725060661_n.jpg" alt="Elite Nightlife at House of Flavor" className="w-full h-full object-cover opacity-50" data-id="element-1431" />
        </div>

        <div className="relative z-20 text-center px-4 max-w-5xl mx-auto" data-id="element-1432">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1433">
            <div className="inline-block mb-6" data-id="element-1434">
              <span className="text-[#DDA247] text-sm font-bold uppercase tracking-[0.3em] border border-[#DDA247] px-6 py-2" data-id="element-1435">
                Friday & Saturday • 11PM - 3AM
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black mb-8 tracking-tighter uppercase" data-id="element-1436">
              Night<span className="text-[#DDA247]" data-id="element-1437">life</span>
            </h1>
            <p className="text-lg md:text-2xl text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-1438">
              Where celebrities, athletes, and entertainers come to celebrate.
              Experience the pinnacle of Laurel's elite nightlife scene.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-1439">
              <Link to="/bottle-service" data-id="element-1440">
                <Button size="lg" className="min-w-[220px]" data-id="element-1441">
                  RESERVE VIP TABLE
                </Button>
              </Link>
              <div className="text-center md:text-left" data-id="element-1442">
                <p className="text-[#DDA247] text-[10px] font-black uppercase tracking-[0.2em] mb-1" data-id="element-1443">
                  Direct VIP Booking
                </p>
                <a href="sms:3014549401" className="text-2xl md:text-3xl font-black text-white hover:text-[#DDA247] transition-colors" data-id="element-1444">
                  301.454.9401
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 1
      }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20" data-id="element-1445">
          <div className="w-[1px] h-24 bg-gradient-to-b from-transparent via-[#DDA247] to-transparent animate-pulse" data-id="element-1446" />
        </motion.div>
      </section>

      {/* The Atmosphere */}
      <section className="py-16 md:py-20 bg-[#0B1014]" data-id="element-1447">
        <div className="container mx-auto px-6" data-id="element-1448">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16" data-id="element-1449">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-1450">
              <span className="text-[#DDA247] text-sm font-bold uppercase tracking-[0.3em] mb-4 block" data-id="element-1451">
                The Experience
              </span>
              <h2 className="text-4xl md:text-5xl font-bold mb-8 uppercase tracking-tight" data-id="element-1452">
                The <span className="text-[#DDA247]" data-id="element-1453">Atmosphere</span>
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed mb-8" data-id="element-1454">
                Step into a world of immersive luxury. Our 190ft video wall
                creates a dynamic visual canvas that pulses with every beat,
                while our state-of-the-art sound system delivers each note with
                crystal clarity.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-1455">
                {features.map(f => <div key={f.title} data-id="element-1456">
                    <div className="w-10 h-10 rounded-lg bg-[#DDA247]/10 flex items-center justify-center text-[#DDA247] mb-3" data-id="element-1457">
                      <f.icon size={20} data-id="element-1458" />
                    </div>
                    <h4 className="font-bold text-white uppercase text-sm tracking-widest mb-1" data-id="element-1459">
                      {f.title}
                    </h4>
                    <p className="text-gray-500 text-xs leading-relaxed" data-id="element-1460">
                      {f.description}
                    </p>
                  </div>)}
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative" data-id="element-1461">
              <div className="absolute -inset-4 border border-[#DDA247]/20 rounded-3xl -z-10" data-id="element-1462" />
              <img src="https://cdn.magicpatterns.com/uploads/ad6jT6urC8DptPHknEKxeE/SnapInsta.to_686901633_17925323268315122_4386797257290448497_n.jpg" alt="Nightlife Atmosphere" className="rounded-2xl shadow-2xl w-full h-[500px] object-cover" data-id="element-1463" />
            </motion.div>
          </div>

          {/* VIP Bottle Service */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#11161A] border border-white/5 rounded-3xl overflow-hidden" data-id="element-1464">
            <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-1465">
              <div className="p-8 md:p-16" data-id="element-1466">
                <div className="flex items-center gap-3 mb-6" data-id="element-1467">
                  <Crown className="text-[#DDA247]" size={32} data-id="element-1468" />
                  <h2 className="text-3xl md:text-4xl font-bold uppercase tracking-tight" data-id="element-1469">
                    VIP Bottle Service
                  </h2>
                </div>
                <p className="text-gray-400 text-lg mb-10 leading-relaxed" data-id="element-1470">
                  Elevate your night with our premium VIP experience. Our
                  dedicated bottle service team ensures your celebration is
                  seamless from arrival to the final track.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-1471">
                  {vipBenefits.map((benefit, i) => <motion.div key={benefit} initial={{
                  opacity: 0,
                  x: -10
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: i * 0.1
                }} className="flex items-center gap-3" data-id="element-1472">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#DDA247]" data-id="element-1473" />
                      <span className="text-gray-300 text-sm font-medium uppercase tracking-wider" data-id="element-1474">
                        {benefit}
                      </span>
                    </motion.div>)}
                </div>
                <Link to="/bottle-service" data-id="element-1475">
                  <Button variant="primary" size="lg" fullWidth data-id="element-1476">
                    Request VIP Table
                  </Button>
                </Link>
              </div>
              <div className="relative min-h-[400px]" data-id="element-1477">
                <img src="https://cdn.magicpatterns.com/uploads/eSNnVE12Pb6djuzdqREZxv/SnapInsta.to_684815228_18095302001328170_2447475437854116174_n.jpg" alt="VIP Table with Bottle Service" className="absolute inset-0 w-full h-full object-cover" data-id="element-1478" />
                <div className="absolute inset-0 bg-gradient-to-r from-[#11161A] to-transparent lg:block hidden" data-id="element-1479" />
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-12 bg-[#0B1014]" data-id="element-1480">
        <div className="container mx-auto px-6" data-id="element-1481">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} variants={{
          hidden: {
            opacity: 0
          },
          visible: {
            opacity: 1,
            transition: {
              staggerChildren: 0.15
            }
          }
        }} className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1482">
            {gallery.map((src, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              y: 30
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.6
              }
            }
          }} className="relative h-72 rounded-2xl overflow-hidden group" data-id="element-1483">
                <img src={src} alt={`Nightlife moment ${i + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-1484" />
                <div className="absolute inset-0 bg-[#0B1014]/30 group-hover:bg-[#0B1014]/10 transition-colors" data-id="element-1485" />
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {/* Entry & Dress Code */}
      <section className="py-16 md:py-20 bg-[#0B1014] border-t border-white/5" data-id="element-1486">
        <div className="container mx-auto px-6" data-id="element-1487">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="max-w-4xl mx-auto text-center" data-id="element-1488">
            <ShieldCheck className="text-[#DDA247] mx-auto mb-6" size={48} data-id="element-1489" />
            <h2 className="text-4xl font-bold mb-8 uppercase tracking-tight" data-id="element-1490">
              Entry & Dress Code
            </h2>
            <p className="text-gray-400 text-lg mb-12 leading-relaxed" data-id="element-1491">
              To maintain our elite atmosphere, we enforce a strict dress code.
              Management reserves the right to deny entry based on attire or
              conduct.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1492">
              {[{
              label: 'Age Requirement',
              value: '21+ ONLY',
              sub: 'Valid ID Required'
            }, {
              label: 'Dress Code',
              value: 'UPSCALE',
              sub: 'No Athletic Wear'
            }, {
              label: 'Cover Charge',
              value: 'VARIES',
              sub: 'Check Event Details'
            }].map((item, i) => <motion.div key={item.label} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="p-8 bg-[#11161A] rounded-2xl border border-white/5" data-id="element-1493">
                  <h4 className="text-[#DDA247] font-black uppercase text-xs tracking-widest mb-4" data-id="element-1494">
                    {item.label}
                  </h4>
                  <p className="text-2xl font-bold text-white" data-id="element-1495">{item.value}</p>
                  <p className="text-gray-500 text-xs mt-2" data-id="element-1496">{item.sub}</p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-1497" />
    </div>;
}